
export class GiiApskaitaFilterApi {
  dokumentoTipas: any;
  busena: any;
  vidineBusena: any;
  metai: any;
  subjektoTipas: any;
  subjektas: string = '';
  atsakomybesBudas: any;
  orderBy: any;
  orderBySecond: any;
  orderByThird: any;
  page: any;
  pageSize: any;
}
